'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRouterDom = require('react-router-dom');
var reactQuery = require('react-query');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var ReturnsLayout = require('../Layout/ReturnsLayout.js');
var useReturns = require('../../hooks/useReturns.js');
var ReturnsConfigProvider = require('../../providers/ReturnsConfigProvider.js');
var generated = require('../../graphql/generated.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const OrderLookupPage = () => {
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const logComponentRendered = React__default["default"].useRef(() => {
    logEvent({
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER,
      feature: 'OrderLookupPage'
    });
  });
  React.useEffect(() => {
    logComponentRendered.current();
  }, []);
  const navigate = reactRouterDom.useNavigate();
  const {
    prefill,
    setOrderData,
    initAuthenticatedClient,
    setSubmittedReturnsForOrder,
    overrideCode
  } = useReturns["default"]();
  const {
    isHipaaCompliant,
    token
  } = ReturnsConfigProvider.useReturnsConfig();
  const {
    error,
    mutate: fetchOrderInfo,
    isLoading
  } = reactQuery.useMutation({
    mutationFn: async _ref => {
      let {
        orderId,
        email,
        overrideCode
      } = _ref;
      logEvent({
        eventType: 'Form submitted',
        feature: 'OrderLookupPage'
      });
      const client = await initAuthenticatedClient({
        orderId,
        email,
        overrideCode,
        token
      });
      let query;
      if (isHipaaCompliant) {
        query = await client.query({
          query: generated.HipaaGetOrderInfoAndSubmittedReturnsDocument,
          variables: {
            orderId
          }
        });
      } else {
        query = await client.query({
          query: generated.GetOrderInfoAndSubmittedReturnsDocument,
          variables: {
            orderId
          }
        });
      }
      const {
        data: {
          getOrderInfo,
          getSubmittedReturnsForOrder
        }
      } = query;
      if (!getOrderInfo || !getSubmittedReturnsForOrder) {
        throw new Error('Could not locate an order with these details');
      }
      setOrderData(getOrderInfo);
      setSubmittedReturnsForOrder(getSubmittedReturnsForOrder.filter(_ref2 => {
        let {
          status
        } = _ref2;
        return status !== 'CANCELLED';
      }));
      navigate('/items');
    }
  });
  const prefillLogin = () => {
    if (token && prefill !== null && prefill !== void 0 && prefill.order || prefill !== null && prefill !== void 0 && prefill.email && prefill !== null && prefill !== void 0 && prefill.order) {
      fetchOrderInfo({
        orderId: prefill.order,
        email: prefill.email,
        ...(overrideCode ? {
          overrideCode
        } : {})
      });
    }
  };
  const prefillLoginRef = React__default["default"].useRef(prefillLogin);
  React.useEffect(() => prefillLoginRef.current(), []);
  const handleSubmit = event => {
    var _event$value, _event$value$find, _event$value2;
    const orderId = (_event$value = event.value) === null || _event$value === void 0 ? void 0 : (_event$value$find = _event$value.find(e => e.type === 'ORDER')) === null || _event$value$find === void 0 ? void 0 : _event$value$find.value;
    const secondaryAuth = (_event$value2 = event.value) === null || _event$value2 === void 0 ? void 0 : _event$value2.find(e => e.type !== 'ORDER');
    if (!orderId || !secondaryAuth) return;
    if (secondaryAuth.type === 'ORDER') return;
    fetchOrderInfo({
      orderId,
      email: secondaryAuth.value,
      ...(overrideCode ? {
        overrideCode
      } : {})
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(ReturnsLayout["default"], {
    orderLookup: {
      onSubmit: handleSubmit,
      loading: isLoading,
      error
    }
  });
};

exports["default"] = OrderLookupPage;
